import { useNavigate, useParams } from "react-router-dom"
import { navigateTo } from "../../../../utils/commonFunctions"

const useNavigation = () => {
    const params = useParams()
    const navigate = useNavigate() // Assume useNavigateFunction is imported from a routing library
    const { mission_name, mission_id } = params as { mission_name: string, mission_id: string }

    const goBack = (page?: 'home' | 'dashboard') => {
        const route = page === 'home' ? '' : `${mission_name}/_details/${mission_id}/Modelling`
        navigateTo(route, navigate)
        return route
    };

    return {
        goBack
    }
}
export default useNavigation